import React from 'react';

const Error: React.FC = () => {
  return (
    <div className="a__popupMessage_pending">
      <div className="w__title">送信失敗について</div>
      <div className="b__note">
        サーバーエラーが発生した為、安否確認を送信できませんでした。
        <div>
          <b>送信失敗のユーザーに再送信する</b>
          <br />
          から再送信を行なってください。
        </div>
      </div>
    </div>
  );
};

export default Error;
